import { render } from "./card-car.svg?vue&type=template&id=52422dee?inline"
const script = {}
script.render = render

export default script